// extracted by mini-css-extract-plugin
export default {"clientList":"ClientList_clientList__VT48Z"};